import * as Yup from 'yup';

export interface IBrandForm {
  // inputGroupCode: number | null;
  name: string | null;
  logo: File | Blob | null;
}

export const brandValidation = Yup.object().shape({
  // inputGroupCode: Yup.number()
  //   .required('دسته بندی برند را انتخاب کنید')
  //   .nullable(),
  name: Yup.string().required('نام برند را انتخاب کنید').nullable(),
  logo: Yup.mixed()
    .required('تصویر لوگوی برند را انتخاب کنید')
    .test('fileType', 'فایل انتخابی باید تصویر باشد', value => {
      if (!value) return true;
      return value instanceof File || value instanceof Blob;
    })
    .nullable(),
});

export const initialValuesBrand: IBrandForm = {
  // inputGroupCode: null,
  name: null,
  logo: null,
};
